/**
 * Quick Fingers: containers open faster.
 *
 * Time spent holding a button in a room you have already cleared is the least interesting time in a
 * raid, and this is the node that buys it back.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const QUICK_FINGERS = {
  id: 'quickFingers',
  branch: 'scavenging',
  tier: 1,
  title: 'Quick Fingers',
  blurb: 'Most pre-war catches were designed to keep children out, and did not.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [{ field: 'interactSeconds', perRank: -0.08, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
